import React from "react";

import { Query as ApolloQuery } from "react-apollo";
import { translate } from "react-i18next";

import AuthenticationErrors from "./AuthenticationErrors";

import { getErrors } from "./errors";

class Query extends React.Component {
  render() {
    const { renderErrors, renderLoading, ...props } = this.props;

    return (
      <ApolloQuery {...props}>
        {({ data, loading, error, refetch }) => {
          if (loading) {
            return renderLoading ? renderLoading() : null;
          }

          if (error) {
            const { errorMessages, authenticationErrors } = getErrors(
              error,
              props.t
            );

            if (errorMessages && errorMessages.length > 1) {
              console.warn(errorMessages);
            }

            return authenticationErrors && authenticationErrors.length
              ? null // This state is handled by the client
              : renderErrors
              ? renderErrors({ errorMessages })
              : null;
          }

          if (data) {
            return this.props.children(data);
          }

          return null;
        }}
      </ApolloQuery>
    );
  }
}

export default translate("translations")(Query);



// WEBPACK FOOTER //
// ./src/graphql/Query.js